const setSearchText = (state, { payload }) => ({
  ...state,
  searchText: payload.searchText,
});

export default setSearchText;
